import {PreselectElement} from './preselect-element';
import {DataRow} from '../../../DoraData/data-row';
import {MessageService} from '../../../messages/message.service';

export class PreselectElements {
  protected preselectElements: PreselectElement[] = [];
  private levelMin = 1;
  private levelMax = 1;

  constructor(levelMin: number, levelMax: number) {
    this.levelMin = levelMin;
    this.levelMax = levelMax;
  }

  /**
   * Load preselectElements tree from datagrid
   */
  public loadPreselectElements(dataRows: DataRow[]): void {
    // empty preselects
    this.preselectElements = [];
    this.loadPreselectElementsLevel(dataRows, 1, 0, this.preselectElements);
  }

  private loadPreselectElementsLevel(dataRows: DataRow[],
                                     level: number,
                                     rowIdx: number,
                                     preselectElementsTarget: PreselectElement[]): number {

    for (let idx = rowIdx; idx < dataRows.length; idx++) {
      const dataRow = dataRows[idx];
      if (dataRow.Level === level) {
        // is my level
        preselectElementsTarget.push(new PreselectElement(dataRow));
      } else if (dataRow.Level === level + 1) {
        // children
        idx = this.loadPreselectElementsLevel(dataRows,
            dataRow.Level,
            idx,
            preselectElementsTarget[preselectElementsTarget.length - 1].children);

      } else if (dataRow.Level === level - 1) {
        // father
        return idx - 1;
      } else {
        console.error('Preselect idx error');
        break;
      }
    }

    return dataRows.length;
  }


  public onSelect(preselectId: string): PreselectElement | null {
    // deselect all
    this.preselectElements.forEach(x => x.deselect());

    // ges selected element
    const preselectedElementSelected = this.findElement(preselectId);
    if (preselectedElementSelected === null) {
      console.error('PreselectElement ' + preselectId + ' not found');
      return null;
    }
    if (preselectedElementSelected.level >= this.levelMin - 1 &&
        preselectedElementSelected.level < this.levelMax) {
      // is my father: select first child
      preselectedElementSelected.children[0].selected = true;
      return preselectedElementSelected.children[0];
    }
  }

  private findElement(id: string): PreselectElement | null {
    this.preselectElements.forEach(x => {
      if (x.findElement(id) !== null) {
        return x;
      }
    });
    return  null;
  }
}
